import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { DashboardCard } from './DashboardCard';
import { airIcon, airQualityCompanyLogo } from '../../../assets';
import { useAirQualitySensorStatus } from '../../../hooks';
import { useCachedStatus } from '../../../hooks/status/useCachedStatus';
import { ROUTE_PATHNAMES } from '../../../routes/routeConstants';
import {
  Status,
  getGlowColors,
  getGradientColors,
  getIconBgColor,
  getIconColor,
  getStatusTextColor,
} from '../../../types/Status';
import {
  mapFilterReplacementStatusToStatus,
  mapFilterReplacementStatusToText,
} from '../../../utils';

export const AirQualityCard = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const { data: cachedStatus } = useCachedStatus('airQuality', useAirQualitySensorStatus);

  const { indoorLabel, filterHealthPercentage, filterReplacementStatus } =
    cachedStatus || {
      status: Status.Good,
      indoorAQI: 0,
      outdoorAQI: 0,
      indoorStatus: Status.Good,
      outdoorStatus: Status.Good,
      indoorLabel: t('air.status.good'),
      filterReplacementStatus: null,
      filterHealthPercentage: 0,
    };

  const text = mapFilterReplacementStatusToText(filterReplacementStatus, filterHealthPercentage, t);
  const displaySecondaryText = t('air.filterStatus');
  const filterStatus = mapFilterReplacementStatusToStatus(filterReplacementStatus);

  return (
    <DashboardCard
      iconSrc={airIcon}
      iconBgColor={getIconBgColor(filterStatus)}
      iconColor={getIconColor(filterStatus)}
      brandLogoSrc={airQualityCompanyLogo}
      middlePrimaryText={text}
      middlePrimaryTextColor={getStatusTextColor(filterStatus)}
      middleSecondaryText={displaySecondaryText}
      bottomPrimaryText={indoorLabel}
      bottomSecondaryText={t('devices.inHome')}
      bottomPrimaryTextColor={getStatusTextColor(filterStatus)}
      backgroundGradientColors={getGradientColors(filterStatus)}
      glowGradientColors={getGlowColors(filterStatus)}
      onPress={() => navigate(ROUTE_PATHNAMES.air)}
    />
  );
};
